import React from 'react'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'

// For the affirmBackup prompt: a previously-verified backup email whose
// confirmation has gone stale. No code round trip — mirrors affirmPrimary.
const EmailVerificationAffirmBackupOffer = (props) => {
  const {
    email, onAffirm, onDifferentEmail, onRemindLater,
    remindLoading, confirmLoading, confirmedMessage, errorMessage,
  } = props

  return (
    <div className='emailVerificationFlow-primaryOffer'>
      <EmailVerificationEnvelopeIllustration checkColor={confirmedMessage ? '#30C99C' : undefined} />
      <div className='emailVerificationFlow-title'>Is this still your backup email?</div>
      <div className='emailVerificationFlow-emailBox'>
        <div className='emailVerificationFlow-emailBox-label'>Backup email</div>
        <div className='emailVerificationFlow-emailDisplay'>{email}</div>
      </div>
      {errorMessage && (
        <div className='emailVerificationFlow-error'>{errorMessage}</div>
      )}
      {confirmedMessage && (
        <div className='emailVerificationFlow-codeEntry-verifiedMessage'>{confirmedMessage}</div>
      )}
      <button
        type='button'
        className={`btn btn--blue btn--large${(confirmLoading || confirmedMessage) ? ' btn--disabled' : ''}`}
        onClick={onAffirm}
        disabled={confirmLoading || !!confirmedMessage}
      >
        Yes, it is
      </button>
      {!confirmedMessage && (
        <div className='emailVerificationFlow-primaryOffer-links'>
          <button type='button' className='emailVerificationFlow-linkBtn' onClick={onDifferentEmail}>
            That’s not my backup email
          </button>
          <button
            type='button'
            className='emailVerificationFlow-linkBtn'
            onClick={onRemindLater}
            disabled={remindLoading}
          >
            Remind me later
          </button>
        </div>
      )}
    </div>
  )
}

export default EmailVerificationAffirmBackupOffer
